module.exports = __webpack_public_path__ + "static/media/logo.503cab32.png";